var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17759 3.22194C1.05955 3.1512 0.924845 3.11305 0.787237 3.11139C0.649629 3.10972 0.514042 3.14459 0.394314 3.21244C0.274585 3.28029 0.175003 3.37869 0.105729 3.4976C0.0364554 3.61651 -2.88591e-05 3.75168 1.71277e-08 3.88929V16.3341C1.71277e-08 17.3656 0.409734 18.3548 1.13907 19.0841C1.8684 19.8134 2.85758 20.2232 3.88901 20.2232H21.0007C22.0321 20.2232 23.0213 19.8134 23.7506 19.0841C24.48 18.3548 24.8897 17.3656 24.8897 16.3341V3.88929C24.8897 3.75168 24.8532 3.61651 24.784 3.4976C24.7147 3.37869 24.6151 3.28029 24.4954 3.21244C24.3757 3.14459 24.2401 3.10972 24.1025 3.11139C23.9648 3.11305 23.8302 3.1512 23.7121 3.22194L12.4448 9.9826L1.17759 3.22194Z",
    fill: "#367AF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17759 3.22194C1.05955 3.1512 0.924845 3.11305 0.787237 3.11139C0.649629 3.10972 0.514042 3.14459 0.394314 3.21244C0.274585 3.28029 0.175003 3.37869 0.105729 3.4976C0.0364554 3.61651 -2.88591e-05 3.75168 1.71277e-08 3.88929V16.3341C1.71277e-08 17.3656 0.409734 18.3548 1.13907 19.0841C1.8684 19.8134 2.85758 20.2232 3.88901 20.2232H21.0007C22.0321 20.2232 23.0213 19.8134 23.7506 19.0841C24.48 18.3548 24.8897 17.3656 24.8897 16.3341V3.88929C24.8897 3.75168 24.8532 3.61651 24.784 3.4976C24.7147 3.37869 24.6151 3.28029 24.4954 3.21244C24.3757 3.14459 24.2401 3.10972 24.1025 3.11139C23.9648 3.11305 23.8302 3.1512 23.7121 3.22194L12.4448 9.9826L1.17759 3.22194Z",
    fill: "url(#paint0_linear_2307_16256)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17759 3.22194C1.05955 3.1512 0.924845 3.11305 0.787237 3.11139C0.649629 3.10972 0.514042 3.14459 0.394314 3.21244C0.274585 3.28029 0.175003 3.37869 0.105729 3.4976C0.0364554 3.61651 -2.88591e-05 3.75168 1.71277e-08 3.88929V16.3341C1.71277e-08 17.3656 0.409734 18.3548 1.13907 19.0841C1.8684 19.8134 2.85758 20.2232 3.88901 20.2232H21.0007C22.0321 20.2232 23.0213 19.8134 23.7506 19.0841C24.48 18.3548 24.8897 17.3656 24.8897 16.3341V3.88929C24.8897 3.75168 24.8532 3.61651 24.784 3.4976C24.7147 3.37869 24.6151 3.28029 24.4954 3.21244C24.3757 3.14459 24.2401 3.10972 24.1025 3.11139C23.9648 3.11305 23.8302 3.1512 23.7121 3.22194L12.4448 9.9826L1.17759 3.22194Z",
    fill: "url(#paint1_linear_2307_16256)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17759 3.22194C1.05955 3.1512 0.924845 3.11305 0.787237 3.11139C0.649629 3.10972 0.514042 3.14459 0.394314 3.21244C0.274585 3.28029 0.175003 3.37869 0.105729 3.4976C0.0364554 3.61651 -2.88591e-05 3.75168 1.71277e-08 3.88929V16.3341C1.71277e-08 17.3656 0.409734 18.3548 1.13907 19.0841C1.8684 19.8134 2.85758 20.2232 3.88901 20.2232H21.0007C22.0321 20.2232 23.0213 19.8134 23.7506 19.0841C24.48 18.3548 24.8897 17.3656 24.8897 16.3341V3.88929C24.8897 3.75168 24.8532 3.61651 24.784 3.4976C24.7147 3.37869 24.6151 3.28029 24.4954 3.21244C24.3757 3.14459 24.2401 3.10972 24.1025 3.11139C23.9648 3.11305 23.8302 3.1512 23.7121 3.22194L12.4448 9.9826L1.17759 3.22194Z",
    fill: "url(#paint2_linear_2307_16256)",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17759 3.22194C1.05955 3.1512 0.924845 3.11305 0.787237 3.11139C0.649629 3.10972 0.514042 3.14459 0.394314 3.21244C0.274585 3.28029 0.175003 3.37869 0.105729 3.4976C0.0364554 3.61651 -2.88591e-05 3.75168 1.71277e-08 3.88929V16.3341C1.71277e-08 17.3656 0.409734 18.3548 1.13907 19.0841C1.8684 19.8134 2.85758 20.2232 3.88901 20.2232H21.0007C22.0321 20.2232 23.0213 19.8134 23.7506 19.0841C24.48 18.3548 24.8897 17.3656 24.8897 16.3341V3.88929C24.8897 3.75168 24.8532 3.61651 24.784 3.4976C24.7147 3.37869 24.6151 3.28029 24.4954 3.21244C24.3757 3.14459 24.2401 3.10972 24.1025 3.11139C23.9648 3.11305 23.8302 3.1512 23.7121 3.22194L12.4448 9.9826L1.17759 3.22194Z",
    fill: "url(#paint3_linear_2307_16256)",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88901 0C2.85758 0 1.8684 0.409734 1.13907 1.13907C0.409734 1.8684 0 2.85758 0 3.88902V4.82238C7.23227e-05 4.95793 0.0355659 5.0911 0.102963 5.2087C0.17036 5.32631 0.267321 5.42426 0.384235 5.49285L12.0513 12.3375C12.1706 12.4075 12.3065 12.4444 12.4448 12.4444C12.5832 12.4444 12.7191 12.4075 12.8384 12.3375L24.5055 5.49285C24.6224 5.42426 24.7193 5.32631 24.7867 5.2087C24.8541 5.0911 24.8896 4.95793 24.8897 4.82238V3.88902C24.8897 2.85758 24.48 1.8684 23.7506 1.13907C23.0213 0.409734 22.0321 0 21.0007 0H3.88901Z",
    fill: "url(#paint4_linear_2307_16256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2307_16256",
    x1: 15.6043,
    y1: 6.46538,
    x2: 23.2143,
    y2: 19.6258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#0094F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#0094F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2307_16256",
    x1: 8.88873,
    y1: 4.91288,
    x2: 0.423124,
    y2: 20.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#0094F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#0094F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2307_16256",
    x1: 19.008,
    y1: 13.3209,
    x2: 20.3115,
    y2: 21.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2307_16256",
    x1: 16.2965,
    y1: 5.21312,
    x2: 18.6766,
    y2: 22.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FF6CE8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6CE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2307_16256",
    x1: 7.39379,
    y1: -3.87813,
    x2: 16.169,
    y2: 17.2952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#29C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4894FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailImage);
export default __webpack_public_path__ + "static/media/mailImage.8ad36c2036464033bbfe8d2044412834.svg";
export { ForwardRef as ReactComponent };